import { connect } from 'react-redux';
import CFilterOrderComponent from './CFilterOrderComponent';
import { Dispatch } from 'redux';
import { AppState } from '../../redux';
import { rowClick, downloadURL, onbulkDownload, approvalRequired, onBulkDownloadStl } from 'src/actions/completeOrderAction';
import { RowDataCompleted } from 'src/reducers/completeorderfile';
import { rework } from 'src/actions/liveOrderAction';
import { doCheckAuthentication } from 'src/actions/aunthenticateAction';
import { getCustDataFilter, getMInproductionOrderData, getMInproductionOrderDataFilter, getPreviewData, resetPreviewData } from 'src/actions/manufacturAction';
import { push } from 'react-router-redux';
import { orderno, orderDisabled } from 'src/actions/supportAction';
import { downloadAttachment } from 'src/actions/rxformAction';
import { renderSTLImage } from 'src/actions/stlViewerAction';
import { GetFileData } from 'src/reducers/rxForm';
import { openVideoPlayerURLArray } from 'src/actions/landingPageAction';
// import { push } from 'react-router-redux';
// import {
//     saveFeedbackType,
//     saveCommands,
//     doFeedback
// } from '../../actions/feedbackAction';

export const mapStateToProps = (state: AppState) => {
    return {

        userDetails: state.user.userDetails,

        mfilteredOrderData: state.manufactur.mfilteredOrderData,
        isDownloading: state.completeOrder.isDownloading,
        redesignReasons: state.completeOrder.redesignReasons,
        orderDataTat: state.fileUpload.orderDataTat,

        previewOrderData: state.manufactur.previewOrderData
    };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
    return {
        onComponentDidMount: () => {
            // dispatch(getCompleteOrderData);
            // dispatch(getRedesignReasons);
        },
        onComponentWillMount: () => {
            dispatch(doCheckAuthentication);
        },
        reload: () => {
            dispatch(getMInproductionOrderDataFilter('', '', new Date(), new Date(), 'ALL'));
        },
        onRowClick: (orderid: string, rowData: string, feedback: string ) => {
            dispatch(rowClick(orderid, rowData));
        },
        onDownloadClick: (filepath: string, fileName: string) => {
            dispatch(downloadURL(filepath, fileName, 'Final Scan'));
        },
        onBulkDownload: (completedData: RowDataCompleted[] | RowDataCompleted) => {
            dispatch(onbulkDownload(completedData, true));
        },
        onBulkDownloadStl: (completedData: RowDataCompleted[] | RowDataCompleted, filetype: string) => {
            dispatch(onBulkDownloadStl(completedData, filetype, true));
        },
        approvalRequired: (array: Array<object>) => {
            dispatch(approvalRequired(array));
        },
        redesignRequest: (columns: Object) => {
            dispatch(rework(columns, 'mfilter'));
        },
        dateFilter: () => {
            dispatch(getMInproductionOrderData);
        },
        dateReset: () => {
            dispatch(getMInproductionOrderData);
        },
        caseFilter: (fcaseno: string, tcaseno: string, startDate: Date | null, endDate: Date | null, status: string) => {
            dispatch(getMInproductionOrderDataFilter(fcaseno, tcaseno, startDate, endDate, status));
        },
        caseFilterCust: (fcaseno: string, tcaseno: string) => {
            dispatch(getCustDataFilter(fcaseno, tcaseno));
        },
        downloadFile: (filepath: string, filename: string, status: string) => {
            dispatch(downloadURL(filepath, filename, status));
        },
        supportPage: (order: string) => {
            dispatch(orderno(order));
            dispatch(orderDisabled(true));
            dispatch(push('/app/support'));
        },
        getPreviewData: (ordernum: string) => {
            dispatch(getPreviewData(ordernum));
        },
        resetPreviewData: () => {
            dispatch(resetPreviewData);
        },
        msgAtt: (msgAttachment: string) => {
            dispatch(downloadAttachment(msgAttachment));
        },
        goStlViewer: (data: GetFileData[]) => {
            dispatch(renderSTLImage(data));
        },
        openVideoPlayerURL: (fullPath: string[], fpath: string) => {
            dispatch(openVideoPlayerURLArray(fullPath, fpath));
        }
    };
};

const CFilterOrderContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(CFilterOrderComponent);

export default CFilterOrderContainer;



// WEBPACK FOOTER //
// ./src/components/CFilterOrder/CFilterOrderContainer.tsx